import React, { useEffect, useState } from "react";
import { ComboBox, FormSection, TextInput } from "../../../components";

export default function FormPesquisaPorGrupos({
  // initialConsulta,
  categorias,
  situacoesAnimal,
  sexos,
  variedades,
  centrais,
  //   handleInputCategoria,
  //   handleInputSituacaoAnimal,
  //   handleInputSexo,
  //   handleInputVariedade,
  //   handleInputCentral,
  handleConsulta,
}) {
  const [consulta, setConsulta] = useState("");
  const [dropdownCategoria, setDropdownCategoria] = useState(false);
  const [inputDropdownCategoria, setInputDropdownCategoria] = useState("Todas");
  const [dropdownSituacaoAnimal, setDropdownSituacaoAnimal] = useState(false);
  const [
    inputDropdownSituacaoAnimal,
    setInputDropdownSituacaoAnimal,
  ] = useState("Todas");
  const [dropdownSexo, setDropdownSexo] = useState(false);
  const [inputDropdownSexo, setInputDropdownSexo] = useState("Todas");
  const [dropdownCentral, setDropdownCentral] = useState(false);
  const [inputDropdownCentral, setInputDropdownCentral] = useState("Todas");
  const [dropdownVariedade, setDropdownVariedade] = useState(false);
  const [inputDropdownVariedade, setInputDropdownVariedade] = useState("Todas");
  const [depsOpen, setDepsOpen] = useState(true);

  const handleInputCategoria = (value) => {
    if (value === "") {
      setInputDropdownCategoria("Todas");
      setConsulta({ ...consulta, categoria: "" });
    } else {
      setInputDropdownCategoria(value.nome);
      setConsulta({ ...consulta, categoria: value.codigo });
    }
  };

  const handleInputSituacaoAnimal = (value) => {
    if (value === "") {
      setInputDropdownSituacaoAnimal("Todas");
      setConsulta({ ...consulta, situacao: "" });
    } else {
      setInputDropdownSituacaoAnimal(value.nome);
      setConsulta({ ...consulta, situacao: value.id });
    }
  };

  const handleInputSexo = (value) => {
    if (value === "") {
      setInputDropdownSexo("Todas");
      setConsulta({ ...consulta, sexo: "" });
    } else {
      setInputDropdownSexo(value.nome);
      setConsulta({ ...consulta, sexo: value.id });
    }
  };

  const handleInputCentral = (value) => {
    if (value === "") {
      setInputDropdownCentral("Todas");
      setConsulta({ ...consulta, central: "" });
    } else {
      setInputDropdownCentral(value.descricao);
      setConsulta({ ...consulta, central: value.id });
    }
  };

  const handleInputVariedade = (value) => {
    if (value === "") {
      setInputDropdownVariedade("Todas");
      setConsulta({ ...consulta, variedade: "" });
    } else {
      setInputDropdownVariedade(value.nome);
      setConsulta({ ...consulta, variedade: value.codigo });
    }
  };

  const handleInput = (event) => {
    const { name, value } = event.target;
    setConsulta({ ...consulta, [name]: value });
  };

  useEffect(() => {
    handleConsulta(consulta);
    // eslint-disable-next-line
  }, [consulta]);

  return (
    <div className="main-content">
      <FormSection title="Pesquisa por Grupo" borderBottomWidth={412}>
        <ComboBox
          items={categorias.filter((categoria) =>
            ["CL", "LA", "PA", "PC", "PO", "PI"].includes(categoria.codigo)
          )}
          displayName="codigo"
          placeholder="Categoria"
          handleInput={(item) => handleInputCategoria(item)}
        />

        <ComboBox
          items={situacoesAnimal}
          displayName="nome"
          placeholder="Situação Animal"
          handleInput={(item) => handleInputSituacaoAnimal(item)}
        />

        <ComboBox
          items={sexos}
          displayName="nome"
          placeholder="Sexo"
          handleInput={(item) => handleInputSexo(item)}
        />

        <ComboBox
          items={centrais}
          displayName="descricao"
          placeholder="Central"
          handleInput={(item) => handleInputCentral(item)}
        />

        <ComboBox
          items={variedades}
          displayName="nome"
          placeholder="Variedade"
          handleInput={(item) => handleInputVariedade(item)}
        />

        <input
          placeholder="Data inicial"
          name="dataInicial"
          type="date"
          onChange={(value) => handleInput(value)}
        />

        <input
          placeholder="Data final"
          name="dataFinal"
          type="date"
          onChange={(value) => handleInput(value)}
        />
      </FormSection>
    </div>
  );
}
